import { monolithMoment } from "@/utils/date-format";
import { styled } from "@monolith-forensics/monolith-ui";
import { ArrowRightIcon } from "lucide-react";
import moment from "moment";

const NoteTitle = styled.div`
  font-weight: 500;
  width: fit-content;
`;

const NoteSubtitle = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.text.secondary};
  width: fit-content;
`;

const NoteTimestamp = styled(NoteSubtitle)`
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const ViewNoteAlert = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 100%;
  display: none;
  align-items: center;
`;

const StyledContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 10px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.background.default};
  border: 1px solid ${({ theme }) => theme.palette.input.border};

  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.palette.action.hover};

    ${ViewNoteAlert} {
      display: flex;
    }
  }
`;

type NoteData = {
  note_tag: string;
  created_by: {
    full_name: string;
  };
  created_on: string;
};

export const NotesListItem: React.FC<{
  data: NoteData;
  onClick?: (data: NoteData) => void;
}> = ({ data, onClick }) => {
  return (
    <StyledContainer
      className={"timeline-notes-list-item"}
      onClick={() => onClick?.(data)}
    >
      <NoteTitle>{data.note_tag}</NoteTitle>
      <NoteSubtitle>{data.created_by.full_name}</NoteSubtitle>
      <NoteTimestamp
        title={monolithMoment({
          timestamp: data.created_on,
          includeTime: true,
          includeZone: true,
        })}
      >
        {moment.utc(data.created_on).fromNow()}
      </NoteTimestamp>
      <ViewNoteAlert>
        <ArrowRightIcon size={20} />
      </ViewNoteAlert>
    </StyledContainer>
  );
};
